import { useEffect, useRef, useState } from "react";
import { FixMeLater } from "types";

const useInput = (
  initialValue: string,
  onChangeCallback?: (value: any) => void,
  formatter?: ((value: string) => any) | null,
  focusOnMount?: boolean,
  propsValue?: string
) => {
  const ref = useRef<FixMeLater>(null);
  const [localValue, setLocalValue] = useState(initialValue);
  const value = propsValue ?? localValue;

  const onChange = (e: FixMeLater) => {
    const value = e.target.value;
    const formattedValue = formatter ? formatter(value) : value;
    setLocalValue(formattedValue);
    onChangeCallback && onChangeCallback(formattedValue);
  };

  useEffect(() => {
    if (focusOnMount) {
      ref.current && ref.current.focus();
    }
  }, [ref.current]);

  useEffect(() => {
    if (initialValue && onChangeCallback) {
      onChangeCallback(initialValue);
    }
  }, []);

  return {
    value,
    setValue: setLocalValue,
    reset: () => setLocalValue(""),
    onChange,
    bind: {
      value,
      onChange,
    },
    ref,
  };
};

export default useInput;
